import styled from '../../../theme'

const HeaderBadge = styled.div<IHeaderBadge>`
  min-width: 50px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  height: ${({ size }) => 26 * size}px;
  min-height: ${({ size }) => 26 * size}px;
  white-space: nowrap;
  font-family: 'Open Sans';
  font-size: ${({ size }) => 14 * size}px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  line-height: ${({ size }) => 26 * size}px;
  text-align: center;
  margin-top: ${({ size }) => 5 * size}px;
  letter-spacing: 0.14px;
  padding: 0px ${({ size }) => 9 * size}px;
  color: ${props => props.color};
  background-color: ${props => props.bgcolor};
`

export default HeaderBadge

export interface IHeaderBadge {
  color?: string
  bgcolor?: string
  size?: number
}
